import React from 'react';
import { createRoot } from 'react-dom/client';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { initMicroFrontendConfig } from '@cko/dashboard-shared';

import { datadogRum } from '@datadog/browser-rum';
import App from './App';
import settings from './services/app-settings';

(async () => {
  datadogRum.init({
    applicationId: settings.datadog.appId,
    beforeSend: () => {
      const shouldSendEvent = settings.app.env !== 'local';
      return shouldSendEvent;
    },
    clientToken: settings.datadog.clientToken,
    env: settings.app.env,
    excludedActivityUrls: [(url) => url.startsWith('https://heapanalytics.com/h?')],
    premiumSampleRate: 100,
    sampleRate: 100,
    service: 'dashboard-ui',
    site: 'datadoghq.com',
    trackInteractions: true,
    version: 'latest',
  });

  const LDProvider: React.FunctionComponent<{ children: React.ReactNode }> =
    await asyncWithLDProvider({
      clientSideID: settings.launchDarkly.clientSideID,
    });

  initMicroFrontendConfig(settings.microfrontendConfig, settings.app.env);

  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Element with id `root` does not exist');
  }

  if (LDProvider) {
    createRoot(rootElement).render(
      <LDProvider>
        <App />
      </LDProvider>,
    );
  } else {
    createRoot(rootElement).render(<App />);
  }
})();
